import { CampaignColumn as BaseCampaignColumn } from '@bingads-webui-campaign/campaignui-common-columns';

export class Campaign extends BaseCampaignColumn {
  constructor({ deps, scope }) {
    super({
      i18n: deps.i18n,
      scope,
      routeTemplate: ({ cid, aid, cmpid }) => `#customer/${cid}/account/${aid}/campaign/${cmpid}/edit/locations`,
      isForVNext: deps.isForVNext,
    });
  }
}
